import { Text, View } from "@react-pdf/renderer";

export function Message({ styles }: { styles: any }) {
  return (
    <View style={{ ...styles.section, marginTop: "0px" }}>
      <Text style={styles.text}>
        {`We'll reallocate your payments if, after insurance adjustments, your responsibility shifts from one provider to another. This can happen when one provider bills earlier than expected.`}
      </Text>
    </View>
  );
}
